import { Component } from '@angular/core';
import { TranslationService } from '@dch/ng-common';

@Component({
  selector: 'my-bill-expired-token',
  templateUrl: './expired-token.component.html',
  standalone: false,
})
export class ExpiredTokenComponent {
  get pageTitle() {
    return window.location.pathname.includes('/Personal')
      ? 'bills.billsScreen.titles.RES'
      : 'bills.billsScreen.titles.SE';
  }
  constructor(private translationService: TranslationService) {}
  goToLogin(): void {
    window.location.assign(
      this.translationService.getTranslatedValueFor(
        'bills.expiredToken.loginUrl'
      )
    );
  }
}
